import { render, staticRenderFns } from "./AddMovie.vue?vue&type=template&id=58a70af2&"
import script from "./AddMovie.vue?vue&type=script&lang=js&"
export * from "./AddMovie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports